import React, { useCallback, useEffect, useState } from "react";
import {
  Box,
  Typography,
  Card,
  CardContent,
  Button,
  Grid,
  useMediaQuery,
  useTheme,
  Link,
  CircularProgress,
} from "@mui/material";
import { getTodaypractices, submitTodayPractice } from "../../services/AttendanceServices";
import { toast } from "react-toastify";
import ErrorScreen from "../ErrorScreen";
import SubmitPracticeModal from "./SubmitPracticeModal";
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';

const TodaysPractice = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const storedPath = localStorage.getItem("practicePath");
  const [showModal, setShowModal] = useState(false);

  const parts = storedPath?.split("/") || [];
  const moduleId = parts.length >= 4 ? parts[3] : null;
  useEffect(() => {
    if (!moduleId) {
      const message = "Please scan QR code for daily practice assignment."
      setErrorMessage(message);
    } else {
      const fetchData = async () => {
        try {
          if (moduleId) {
            setLoading(true);
            const response = await getTodaypractices(moduleId);
            setData(response?.data?.data);
          }
        } catch (error) {
          let message =
            error.response?.data?.message ||
            "Something went wrong. Please try again later.";
          toast.error(message);
        } finally {
          setLoading(false);
        }
      }
      fetchData()
    }
  }, [moduleId]);

  const handleSubmitPractice = useCallback(() => {
    setShowModal(true);
  }, []);

  const handleSubmit = async (practiceLink) => {
    try {
      const obj = { submission_link: practiceLink };
      const response = await submitTodayPractice(
        obj,
        data.learnerDailyPractice.learnerDailyPracticeID,
        data.learnerDailyPractice.daily_practice_id
      );
      toast.success(response.message || response.data.message);
    } catch (error) {
      toast.error(error?.message || error?.response?.message || error?.response?.data?.message);
    }
  };

  if (loading) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "80vh",
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "80vh",
      }}
    >   {errorMessage ? (
      <ErrorScreen message={errorMessage} />

    ) : (
      <Card
        sx={{
          width: "100%",
          boxShadow: 3,
          borderRadius: 3,
          minWidth: isMobile ? "100%" : 500,
          position: "relative",
        }}
      >
        <CardContent>
          {
            data?.learnerDailyPractice?.submission_link &&
            <Box sx={{ position: "absolute", top: 10, right: 10 }}>
              <CheckCircleRoundedIcon style={{ color: "green" }} />
            </Box>
          }
          <Typography
            variant="h6"
            sx={{
              textAlign: "center",
              fontWeight: "bold",
              mb: 2,
            }}
          >
            Today's Practice/Test
          </Typography>

          <Grid container spacing={2} sx={{ paddingLeft: "15%" }}>
            <Grid item xs={12} sm={6}>
              <Typography variant="subtitle1" fontWeight="bold">
                Module:
              </Typography>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Typography variant="body1">
                {data?.moduleDetails?.module_Name || "-"}
              </Typography>
            </Grid>

            <Grid item xs={12} sm={6}>
              <Typography variant="subtitle1" fontWeight="bold">
                Topic:
              </Typography>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Typography variant="body1">
                {data?.topicDetails?.topic_Name || "-"}
              </Typography>
            </Grid>

            <Grid item xs={12} sm={6}>
              <Typography variant="subtitle1" fontWeight="bold">
                Notes:
              </Typography>
            </Grid>
            <Grid item xs={12} sm={6}>
              {data?.topicDetails?.topic_pdfPath ? (
                <Link
                  href={data.topicDetails.topic_pdfPath}
                  target="_blank"
                  rel="noopener noreferrer"
                  underline="hover"
                >
                  <Typography variant="body1">notes.pdf</Typography>
                </Link>
              ) : (
                "-"
              )}
            </Grid>
          </Grid>
          {!errorMessage && (
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                mt: 3,
                flexWrap: "wrap"
              }}
            >
              <Button
                variant="contained"
                color="primary"
                sx={{
                  minWidth: 195,
                }}
                disabled={!data?.learnerDailyPractice?.daily_practice_pdf}
                onClick={() =>
                  window.open(data?.learnerDailyPractice?.daily_practice_pdf, "_blank")
                }
              >
                VIEW  MY PRACTICE
              </Button>
              <Button
                variant="contained"
                color="primary"
                onClick={handleSubmitPractice}
                sx={{
                  ml: { xs: 0, sm: 0, md: 2 },
                  mt: { xs: 2, sm: 0, md: 0 },
                  minWidth: 195,
                }}
              >
                SUBMIT MY PRACTICE
              </Button>
            </Box>
          )}
        </CardContent>
      </Card>
    )}
      <SubmitPracticeModal selectedPractice={data} open={showModal} handleClose={() => setShowModal(false)} handleSubmit={handleSubmit} />
    </Box>
  );
};

export default TodaysPractice;
